
import {
  LOAD_TROUBLE_SHOOT_DATA, LOAD_TROUBLE_SHOOT_DATA_FAIL,
  LOAD_TROUBLE_SHOOT_DATA_SUCCESS,
  LoadTroubleShootData, LoadTroubleShootDataFail, LoadTroubleShootDataSuccess,
  TroubleShootDataAction
} from "../actions/troubleshoot.action";

export interface ITroubleShootEntityDataState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface ITroubleShootData {
  entities: {[websiteId: number]: ITroubleShootEntityDataState};
  loading: boolean;
  loaded: boolean;
}

export const initialState: ITroubleShootData = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: ITroubleShootData = initialState, action: TroubleShootDataAction): ITroubleShootData {
  let payload: any;

  switch (action.type) {

    case LOAD_TROUBLE_SHOOT_DATA:
      payload = (<LoadTroubleShootData>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_TROUBLE_SHOOT_DATA_SUCCESS:
      payload = (<LoadTroubleShootDataSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_TROUBLE_SHOOT_DATA_FAIL:
      payload = (<LoadTroubleShootDataFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
